var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowName)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),_c('BigPowerTable',{attrs:{"data":_vm.data.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }